<template>
    <div class="container" v-if="showPanel">
        <div v-if="!isShowChat" class="content">
            <div class="header-wrap">
                <img v-if="config.iconImg" class="header-icon" :src="config.iconImg" />
                <p class="title">{{config.name}}</p>
                <p class="txt">{{config.description}}</p>
                <div class="qustion-wrap">
                    <div class="qustion-item" v-for="(item,index) in config.items" :key="index" @click="questionClick(item)">
                        <div class="left-box">
                            <img class="question-left" :src="require('../assets/images/question-left.png')" />
                            <p class="question">{{item}}</p>
                        </div>
                        <img class="arrow-right" :src="require('../assets/images/arrow-right.png')" />
                    </div>
                </div>
            </div>
            <div class="footer-wrap">
                <div class="footer-box">
                    <textarea v-model="userQustion" class="input" placeholder="输入内容" rows="1" :style="{ height: textareaHeight + 'px', maxHeight: maxTextareaHeight + 'px'}" @input="autoResize"></textarea>
                    <img @click="firstSend" class="send-btn" :src="require('../assets/images/send.png')" fit="cover" />
                </div>
            </div>
        </div>
        <div v-else class="chat-wrap">
            <div class="chat-box">
                <div v-for="(item,index) in chatList" :key="index">
                    <div v-if="item.type == 'assistant'" class="chat-ai">
                        <img class="ai-img" :src="config.iconImg" />
                        <div class="chat" v-if="item.htmlContent" v-html="item.htmlContent"></div>
                        <div class="chat" v-else >{{item.content}}</div>
                    </div>
                    <div v-else class="chat-member">
                        <div class="chat">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <div class="footer-wrap">
                <div class="again-btn" @click="restart">重新开始对话</div>
                <div class="footer-box">
                    <textarea v-model="userQustion" class="input" placeholder="输入内容" :disabled="inputDisabled" rows="1" :style="{ height: textareaHeight + 'px',maxHeight: maxTextareaHeight + 'px' }" @input="autoResize"></textarea>
                    <img @click="send" class="send-btn" :src="require('../assets/images/send.png')" fit="cover" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { initSend, initAgent, saveChat } from '@/api/common'
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import Vue from 'vue';
import { getQueryObject } from '@/api/utils';

export default {
    name: 'PreviewWebPlugin',
    components: {  },
    computed: {
       
    },
    data() {
        return {
            showPanel: false,
            config: {
                iconImg: '',
                name: '',
                description: '',
                items: [],
                introduct: '',
            },
            agentId: '',
            userInfo: {},
            isShowChat: false,

            chatList: [],

            userQustion: '',

            inputDisabled: false,

            textareaHeight: 24, // 初始一行高度（根据字体大小调整）
            maxTextareaRows: 10, // 👉 最大显示 10 行，你可以自己改
            maxTextareaHeight: 24 * 10,

            hasInitUser: false,
        }
    },
    created() {
        this.agentId = getQueryObject('agentId');
        if(this.agentId){
            this.showPanel = true;
            this.initUser()
        }
    },
    beforeDestroy() {
        
    },
    methods: {
        autoResize(e) {
            const el = e.target;
            el.style.height = 'auto'; // 重置

            // 真实内容高度
            let contentHeight = el.scrollHeight;

            // 限制最大高度
            if (contentHeight > this.maxTextareaHeight) {
                contentHeight = this.maxTextareaHeight;
                el.style.overflowY = 'auto';
            } else {
                el.style.overflowY = 'hidden';
            }

            el.style.height = contentHeight + 'px';
            this.textareaHeight = contentHeight;
        },
        resetTextarea() {
            this.textareaHeight = 24;
        },
        async initUser() {
            if (!this.agentId) return;

            try {
                // 初始化用户信息
                // const storedUser = JSON.parse(localStorage.getItem('userInfo') || '{}')

                // this.token = storedUser.token || '';

                // const userRes = await init({
                //     agentId: this.agentId,
                //     token: this.token
                // });

                // if (userRes?.data) {
                //     localStorage.setItem('userInfo', JSON.stringify(userRes.data));
                //     this.userInfo = userRes.data;
                // }

                // 初始化智能体
                const agentRes = await initAgent({ id: this.agentId });
                if (agentRes?.data) {
                    this.config = agentRes.data;
                    
                    const title = this.config.name || '默认标题';
                    document.title = title;
                    // 兼容 iframe
                    if (window.parent) {
                        window.parent.document.title = title;
                    }
                }

            } catch (error) {
                console.error('初始化失败：', error);
            }
        },
        async ensureInitUser() {
            if (this.hasInitUser) return;

            try {
                const storedUser = JSON.parse(localStorage.getItem('userInfo') || '{}')
                this.token = storedUser.token || '';

                const userRes = await initSend({
                    agentId: this.agentId,
                    token: this.token
                });

                if (userRes?.data) {
                    localStorage.setItem('userInfo', JSON.stringify(userRes.data));
                    this.userInfo = userRes.data;
                }

                this.hasInitUser = true; // ✅ 标记已初始化
            } catch (error) {
                console.error('初始化失败：', error);
            }
        },
        async pushAndSave(msg) {
            this.chatList.push(msg); // 更新视图
            try {
                await saveChat(msg); // 异步保存
            } catch (e) {
                console.error('保存聊天失败:', e);
                msg.failed = true; // 可标记失败
            }
        },
        /** 点击问题列表的问题 **/
        async questionClick(question) {
            await this.ensureInitUser(); // 👈 加这里

            this.isShowChat = true;

            // 如果有开场白，先保存开场白
            if (this.config.introduct) {
                const introduct = {
                    content: this.config.introduct,
                    talkId: this.userInfo.talkId,
                    type: 'assistant',
                };
                await this.pushAndSave(introduct);
            }

            // 保存用户问题
            const info = {
                content: question,
                talkId: this.userInfo.talkId,
                type: 'user',
            };
            await this.pushAndSave(info);

            // 再去调用 AI 流式回答
            this.getAiAnswer(question);
        },
        async getAiAnswer(question) {
            this.inputDisabled = true;
            const aiMsg = Vue.observable({
                content: '',
                htmlContent: '',  // Markdown 转 HTML
                talkId: this.userInfo.talkId,
                type: 'assistant'
            })

            this.chatList.push(aiMsg)

            try {
                const response = await fetch('https://yinheapi.yinheshujie.com/prod-api/api/aiTalk/aiAnswer', {
                    method:'POST',
                    headers:{
                        'Content-Type':'application/json',
                        'Accept': 'text/event-stream',
                        'Authorization':this.userInfo.token
                    },
                    body: JSON.stringify({
                        talkId: this.userInfo.talkId,
                        reqContext: question
                    })
                })

                const reader = response.body.getReader()
                const decoder = new TextDecoder()

                for (;;) {
                    const { done, value } = await reader.read();
                    if(done) break

                    const chunk = decoder.decode(value, { stream: true })
                    const lines = chunk.split('\n')


                    lines.forEach(line => {
                        if(!line) return
                        try{
                            const json = JSON.parse(line.replace('data:', ''));
                            
                            aiMsg.content += json.data.CONTENT || '';
                            
                            // 流式实时渲染 Markdown
                            aiMsg.htmlContent = DOMPurify.sanitize(marked(aiMsg.content));
                            
                            this.scrollBottom();
                        }catch(e){
                            console.log(e)
                        }
                    })
                }

                await saveChat(aiMsg);

            } catch (e) {
                console.error('AI 流式异常:', e);

            } finally {
                this.inputDisabled = false;
            }
        },
        
        scrollBottom(){
            this.$nextTick(()=>{
                const box = this.$el.querySelector('.chat-box')
                if(box){
                    box.scrollTop = box.scrollHeight
                }
            })
        },
        async send(){
            if(this.inputDisabled) return;

            this.inputDisabled = true;
            let qustion = this.userQustion.trim()
            if(qustion){
                const userMsg = Vue.observable({
                    content: qustion,
                    talkId: this.userInfo.talkId,
                    type: 'user'
                })

                await this.pushAndSave(userMsg)
                this.userQustion = ''

                // 输入框回到一行高度
                this.resetTextarea();

                this.getAiAnswer(qustion)

                this.scrollBottom();
            }else{
                return
            }
        },
        async firstSend() {
            if (this.inputDisabled) return;
            let question = this.userQustion.trim();
            if (!question) return;

            await this.ensureInitUser(); // 👈 加这里

            this.inputDisabled = true;

            this.isShowChat = true;

            // 保存开场白
            if (this.config.introduct) {
                const introduct = {
                    content: this.config.introduct,
                    talkId: this.userInfo.talkId,
                    type: 'assistant',
                };
                await this.pushAndSave(introduct);
            }

            // 保存用户消息
            const userMsg = Vue.observable({
                content: question,
                talkId: this.userInfo.talkId,
                type: 'user'
            });
            await this.pushAndSave(userMsg);

            this.userQustion = '';

            // 输入框回到一行高度
            this.resetTextarea();

            // 获取 AI 回答
            try {
                await this.getAiAnswer(question);
            } catch (e) {
                console.error('获取 AI 回答失败:', e);
                this.inputDisabled = false;
            }
        },
        restart(){
            this.userQustion = ''
            this.chatList = []
            this.isShowChat = false

            // 输入框回到一行高度
            this.resetTextarea();

            this.hasInitUser = false // 👈 重置
            this.initUser()
        }
    }
};
</script>


<style lang="scss">
.container{
    width: 100%;
    height: 100%;
    padding: 0 20px 20px;
    box-sizing: border-box;
    .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .header-wrap{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 20%;
            .header-icon{
                width: 72px;
                height: 72px;
                border-radius: 8px;
            }
            .title{
                font-size: 16px;
                margin-top: 16px;
            }
            .txt{
                font-size: 14px;
                color: #8789A0;
                padding: 0 16px;
                margin-top: 12px;
            }
            .qustion-wrap{
                width: 100%;
                height: 200px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                .qustion-item{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 12px;
                    background: #F7F7FC;
                    border-radius: 8px;
                    padding: 14px 15px;
                    box-sizing: border-box;
                    cursor: pointer;
                    .left-box{
                        display: flex;
                        align-items: center;
                    }
                    .question-left{
                        display: flex;
                        align-items: center;
                        margin-right: 15px;
                    }
                    .question{
                        flex: 1;
                        font-size: 14px;
                        font-weight: bold;
                        margin-right: 15px;
                    }
                }
            }
        }
    }
    .footer-wrap{
        width: 100%;
        margin-top: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        
        .again-btn{
            font-size: 14px;
            color: #ffffff;
            padding: 6px 15px;
            background: #0E5FFF;
            border-radius: 4px;
            margin-bottom: 16px;
            cursor: pointer;
        }
        .footer-box{
            width: 100%;
            box-shadow: 0px 0px 6px 1px rgba(177,183,229,0.9);
            border-radius: 8px;
            border: 1px solid #CED2E0;
            padding: 12px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            background: #FFFFFF;
            z-index: 99;
        }
        .send-btn{
            cursor: pointer;
        }
        .input{
            width: 100%;
            border: none;
            font-size: 16px;
            min-height: 24px;   // 一行高度
            resize: none;       // 禁止手动拖拽
            line-height: 24px;
            padding: 0;
            overflow-y: hidden;

            /* 👇 隐藏滚动条，但保留滚动功能 */
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE */
        }
        /* 👇 Chrome / Safari 隐藏滚动条 */
        .input::-webkit-scrollbar {
            display: none;
        }
        .input:hover,
        .input:focus {
            border: none !important;
            outline: none !important;
        }
    }
    .chat-wrap{
        height: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        .chat-box{
            flex: 1;
            overflow-y: auto;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE */
            margin-bottom: 20px;
            .chat-ai{
                display: flex;
                align-items: flex-start;
                margin-top: 16px;
                .ai-img{
                    width: 40px;
                    height: 40px;
                    border-radius: 8px;
                    margin-right: 8px;
                }
            }
            .chat-member{
                margin-top: 16px;
                display: flex;
                justify-content: flex-end;
            }
            .chat{
                background: #F7F7FC;
                border-radius: 8px;
                font-size: 16px;
                padding: 10px 16px;
                line-height: 30px;

                img{
                    width: 100% !important;
                }
            } 
        }
        .chat-box::-webkit-scrollbar{
            display: none; /* Chrome Safari */
        }
    }
}
</style>